var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "design-iconfont",
  viewBox: "0 0 36 36",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#212121",
  fillOpacity: 0.5,
  d: "M18 15.33 30.502 2.292c.812-.822 2.133-.925 3.047 0 .815.82.916 2.154 0 3.078l-12.5 13.04 12.706 12.832c.812.822.812 2.26 0 3.08-.814.821-2.237.821-3.05 0L18 21.489 5.5 34.526c-.814.822-2.135.925-3.05 0-.916-.925-.915-2.154 0-3.078L14.95 18.411 2.245 5.576c-.812-.82-.812-2.258 0-3.08.815-.821 2.238-.821 3.05 0L18.001 15.33z",
  opacity: 0.858
})));
export default SvgCloseIcon;